// Field Services Page Translations
// Supported languages: English (en), Danish (da)
const fieldServiceTranslations = {
  en: {
    pageTitle: "Service Assistant App - RC Service Tool",
    heading: "Service Assistant App",
    currentUser: "Current User",

    profile: "Profile",

    // Day tabs
    tabs: {
      yesterday: "Yesterday",
      today: "Today",
      tomorrow: "Tomorrow",
    },

    jobOrdering: {
      doneReording: "Done Reordering",
      reorderJobs: "Reorder Jobs",
      selectToSwap: "Select to swap",
      jobOrderPickSecond: "Tap another job to swap",
      jobOrderPickFirst: "Tap a job to move it",
      resetToRouteOrder: "Use route order",
      routeOrderChanged:
        "The route order was changed by the office, so your own job order for this day was reset.",
    },

    // Job list
    noJobsForDay: "No jobs for this day.",
    noDevice: "No device",
    tasks: "Tasks",
    new: "New",
    highPriority: "HIGH",
    openButton: "Open",
    completeJobButton: "Complete Job",

    // Job panel header
    elapsed: "elapsed",
    startJob: "Start Job",
    failJob: "Fail Job",
    confirmFailJob: "Confirm Fail Job",
    done: "done",
    reopenJob: "Reopen Job",

    // Fail job form
    jobFailureReason: "Job Failure Reason",
    jobFailureReasonPlaceholder: "Required to fail this job",
    jobFailureReasonHint:
      "Please add a failure reason, then press Confirm Fail Job.",
    failAllPendingTasks: "Fail all pending tasks",
    cancel: "Cancel",

    // Task filter tabs
    taskFilter: {
      todo: "To Do",
      finished: "Finished",
      all: "All",
    },

    // Task list
    noTasksConfigured: "No tasks configured for this job.",
    complete: "Complete",
    fail: "Fail",
    skip: "Skip",
    notApplicable: "N/A",
    details: "Details",
    hideDetails: "Hide Details",

    // Task detail fields
    taskFailureHint: "This task is {status}. Please add a failure note.",
    technicianNotes: "Technician Notes",
    failureNote: "Failure Note",
    failureNotePlaceholder: "Required when failed, skipped, or not applicable",
    failureNoteRequired: "Required before changing to Failed, Skipped, or N/A.",
    partsUsed: "Parts Used (one per line or comma separated)",
    partsUsedPlaceholder: "Only if applicable",
    saveNotes: "Save Notes",

    // Empty drawer state
    selectJobPrompt: "Select a job to view tasks.",

    // Language toggle
    language: "🇬🇧 EN",
  },

  da: {
    pageTitle: "Serviceassistent App - RC Service Tool",
    heading: "Serviceassistent App",
    currentUser: "Nuværende bruger",
    profile: "Profil",

    // Day tabs
    tabs: {
      yesterday: "I går",
      today: "I dag",
      tomorrow: "I morgen",
    },

    jobOrdering: {
      doneReording: "Færdig med omrokering",
      reorderJobs: "Omrokér opgaver",
      selectToSwap: "Vælg for at bytte",
      jobOrderPickSecond: "Vælg en anden opgave for at bytte",
      jobOrderPickFirst: "Tryk på en opgave for at flytte den",
      resetToRouteOrder: "Brug rutens rækkefølge",
      routeOrderChanged:
        "Rutens rækkefølge er blevet ændret af kontoret, så din egen rækkefølge for dagen er nulstillet.",
    },

    // Job list
    noJobsForDay: "Ingen opgaver for denne dag.",
    noDevice: "Ingen enhed",
    tasks: "Opgaver",
    new: "Ny",
    highPriority: "HØJ",
    openButton: "Åbn",
    completeJobButton: "Fuldfør job",

    // Job panel header
    elapsed: "forløbet",
    startJob: "Start job",
    failJob: "Fejl job",
    confirmFailJob: "Bekræft fejl job",
    done: "fuldført",
    reopenJob: "Genåbn job",

    // Fail job form
    jobFailureReason: "Årsag til jobfejl",
    jobFailureReasonPlaceholder: "Påkrævet for at fejle dette job",
    jobFailureReasonHint:
      "Tilføj venligst en fejlårsag og tryk derefter på Bekræft fejl job.",
    failAllPendingTasks: "Fejl alle afventende opgaver",
    cancel: "Annuller",

    // Task filter tabs
    taskFilter: {
      todo: "Udestående",
      finished: "Afsluttet",
      all: "Alle",
    },

    // Task list
    noTasksConfigured: "Ingen opgaver konfigureret for dette job.",
    complete: "Fuldført",
    fail: "Fejl",
    skip: "Spring over",
    notApplicable: "NA",
    details: "Detaljer",
    hideDetails: "Skjul detaljer",

    // Task detail fields
    taskFailureHint: "Denne opgave er {status}. Tilføj venligst en fejlnotat.",
    technicianNotes: "Teknikernoter",
    failureNote: "Fejlnotat",
    failureNotePlaceholder:
      "Påkrævet ved fejl, spring over eller ikke relevant",
    failureNoteRequired:
      "Påkrævet inden ændring til Fejl, Spring over eller Ikke relevant.",
    partsUsed: "Brugte dele (én pr. linje eller kommasepareret)",
    partsUsedPlaceholder: "Kun hvis relevant",
    saveNotes: "Gem noter",

    // Empty drawer state
    selectJobPrompt: "Vælg et job for at se opgaver.",

    // Language toggle
    language: "🇩🇰 DA",
  },
};

export default fieldServiceTranslations;
